function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M16 1.273a5.727 5.727 0 015.726 5.618v4.38l1.335.002a2.667 2.667 0 012.661 2.498l.005.168v10.122a2.667 2.667 0 01-2.498 2.661l-.168.005H8.939a2.667 2.667 0 01-2.661-2.498l-.005-.168V13.939a2.667 2.667 0 012.498-2.661l.168-.005 1.334-.001V7A5.727 5.727 0 0116 1.273zm7.06 11.454H8.94c-.628 0-1.144.477-1.206 1.088l-.007.124v10.122c0 .627.477 1.143 1.088 1.205l.124.007h14.122c.627 0 1.143-.477 1.205-1.088l.007-.124V13.939c0-.627-.477-1.143-1.088-1.205l-.124-.007zM16 15.607a3.394 3.394 0 110 6.787 3.394 3.394 0 010-6.788zm0 1.454a1.94 1.94 0 100 3.878 1.94 1.94 0 000-3.878zm0-14.334a4.273 4.273 0 00-4.272 4.17l-.001 4.375h8.546V7A4.273 4.273 0 0016 2.727z"
});

function SvgPadlock(_ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    preserveAspectRatio: "xMidYMid",
    fill: "currentcolor",
    "data-qa": "svg",
    "aria-labelledby": titleId
  }, props), title ? React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

export default SvgPadlock;